
        
            
            import * as React from "react";
            window['React'] = React;
        
            
            import * as ReactDOMRoot from "react-dom";
            window['ReactDOMRoot'] = ReactDOMRoot;
        
            
            import * as ReactDOMClient from "react-dom/client";
            window['ReactDOMClient'] = ReactDOMClient;
        
            
            import * as ReactUseWebsocket from "react-use-websocket";
            window['ReactUseWebsocket'] = ReactUseWebsocket;
        
            
            import * as Recharts from "recharts";
            window['Recharts'] = Recharts;
        
            
            import * as ReactRouter from "react-router";
            window['ReactRouter'] = ReactRouter;
        
            
            import * as html2canvas from "html2canvas";
            window['html2canvas'] = html2canvas;
        
            
            import * as ReactDnd from "react-dnd";
            window['ReactDnd'] = ReactDnd;
        
            
            import * as Auth0React from "@auth0/auth0-react";
            window['Auth0React'] = Auth0React;
        
            
            import * as Joda from "@js-joda/core";
            window['Joda'] = Joda;
        
            
            import * as NivoBar from "@nivo/bar";
            window['NivoBar'] = NivoBar;
        
            
            import * as NivoBoxplot from "@nivo/boxplot";
            window['NivoBoxplot'] = NivoBoxplot;
        
            
            import * as NivoCore from "@nivo/core";
            window['NivoCore'] = NivoCore;
        
            
            import * as NivoHeatmap from "@nivo/heatmap";
            window['NivoHeatmap'] = NivoHeatmap;
        
            
            import * as NivoLine from "@nivo/line";
            window['NivoLine'] = NivoLine;
        
            
            import * as PopperCore from "@popperjs/core";
            window['PopperCore'] = PopperCore;
        
            
            import * as ReactFlipToolkit from "react-flip-toolkit";
            window['ReactFlipToolkit'] = ReactFlipToolkit;
        
            
            import * as ReactDndHtml5Backend from "react-dnd-html5-backend";
            window['ReactDndHtml5Backend'] = ReactDndHtml5Backend;
        
            
            import * as ReactPopper from "react-popper";
            window['ReactPopper'] = ReactPopper;
        
            
            import * as ReactVirtualizedAutoSizer from "react-virtualized-auto-sizer";
            window['ReactVirtualizedAutoSizer'] = ReactVirtualizedAutoSizer;
        
            
            import * as ReactjsPopup from "reactjs-popup";
            window['ReactjsPopup'] = ReactjsPopup;
        
            
            import * as DateFns from "date-fns";
            window['DateFns'] = DateFns;
        
            
            import * as Marked from "marked";
            window['Marked'] = Marked;
        
            
            import * as _ from "lodash";
            window['_'] = _;
        
            
            import * as EmotionCss from "@emotion/css";
            window['EmotionCss'] = EmotionCss;
        
            
            import * as Fitty from "fitty";
            window['Fitty'] = Fitty;
        
            
            import * as DDWM from "drag-drop-webkit-mobile";
            window['DDWM'] = DDWM;
        
            
            import * as ReactJsxRuntime from "react/jsx-runtime";
            window['ReactJsxRuntime'] = ReactJsxRuntime;
        

        
            
        
    